"use client";

import {
  type MultidietCartStore,
  createMultidietCartStore,
} from "../store/multidiet-cart-store";
import { JSX, createContext, useContext, useRef } from "react";
import { type StoreApi, useStore } from "zustand";

const MultidietCartStoreContext =
  createContext<StoreApi<MultidietCartStore> | null>(null);

type Props = {
  children: JSX.Element;
  storageKey?: string;
};

export const MultidietCartProvider = ({
  children,
  storageKey = "multidiet-cart",
}: Props) => {
  const storeRef = useRef<StoreApi<MultidietCartStore>>(undefined);
  if (!storeRef.current) {
    storeRef.current = createMultidietCartStore({ storageKey });
  }

  return (
    <MultidietCartStoreContext.Provider value={storeRef.current}>
      {children}
    </MultidietCartStoreContext.Provider>
  );
};

export const useMultidietCartStore = <T,>(
  selector: (store: MultidietCartStore) => T
): T => {
  const multidietCartStoreContext = useContext(MultidietCartStoreContext);

  if (!multidietCartStoreContext) {
    throw new Error(
      `useMultidietCartStore must be used within MultidietCartProvider`
    );
  }

  return useStore(multidietCartStoreContext, selector);
};
